
import { Alert } from 'quasar'

let previousAlert;
let deviceinfo;

window.psgo.subscribeFuncs({
  "app.deviceinfo.get": msg => {
    deviceinfo = msg.dat.val;
  }
});

function showAlert(val) {
  if (alert) {
    const colors = {
      "info": "positive",
      "error": "negative",
      "warning": "warning"
    };

    let cfg = {
      html: val.message,
      position: deviceinfo.platform === "browser" ? "top-center" : "bottom-center",
      color: colors[val.type]
    };

    if (val.button) {
      cfg["actions"] = [{ label: val.button, handler: val.buttonCb }];
    }

    if (previousAlert) {
      previousAlert.dismiss();
    }

    let alert = Alert.create(cfg)
    previousAlert = alert;

    if (val.timeout) {
      setTimeout(function () {
        alert.dismiss()
      }, val.timeout);
    }
  }
}

function showError(msg) {
  showAlert({ message: msg, timeout: 5000 })
}

function showInfo(msg) {
  showAlert({ message: msg, timeout: 5000, type: "info" })
}

function hideAlert() {
  if (previousAlert) {
    previousAlert.dismiss();
  }
}

export { showAlert, showError, showInfo, hideAlert };



// WEBPACK FOOTER //
// ./src/js/alerts.js